import { render, staticRenderFns } from "./SuperKidPublicHeader.vue?vue&type=template&id=a5d248e6&scoped=true&"
import script from "./SuperKidPublicHeader.vue?vue&type=script&lang=js&"
export * from "./SuperKidPublicHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuperKidPublicHeader.vue?vue&type=style&index=0&id=a5d248e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d248e6",
  null
  
)

export default component.exports